interface WrongPunchEmployee {
  emp_id: number;
  emp_name: string;
  wrongPunches: number;
}

const WrongPunchesModal = ({
  employees,
}: {
  employees: WrongPunchEmployee[];
}) => {
  if (employees.length === 0) {
    return <div className="text-muted">No employees have wrong punches.</div>;
  }

  return (
    <div className="table-responsive">
      <table className="table table-hover">
        <thead>
          <tr>
            <th>Employee</th>
            <th className="text-end">Wrong Punches</th>
          </tr>
        </thead>
        <tbody>
          {employees.map((employee) => (
            <tr key={employee.emp_id}>
              <td>{employee.emp_name}</td>
              <td className="text-end">
                <span className="wrong-punch-count">
                  {employee.wrongPunches}
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default WrongPunchesModal;
